import { render } from "./NotifyPage.vue?vue&type=template&id=a8517a3a"
import script from "./NotifyPage.vue?vue&type=script&lang=js"
export * from "./NotifyPage.vue?vue&type=script&lang=js"

import "./NotifyPage.vue?vue&type=style&index=0&id=a8517a3a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__